import React from "react";
import { useEffect, useRef, useState } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";

import micro2 from "../../images/microphone.png";
import microVoice from "../../images/microphone-voice.svg";
import micro1 from "../../images/microphone_stop.png";

import "./ConversationStyleSheet.css";
import { s360ConfigService } from "../Services/S360Config";

const TextToSpeech = (props) => {
  const { transcript, finalTranscript, resetTranscript } =
    useSpeechRecognition();
  const [isListening, setIsListening] = useState(false);
  const [text, setText] = useState("");
  const microphoneRef = useRef(null);

  const handleClick = () => {
    let check = !isListening;
    resetTranscript();
    if (check) {
      setIsListening(true);
      
      microphoneRef.current.classList.add("listening");
      SpeechRecognition.startListening({
        continuous: true,
      });
    } else {
      stopHandle();
    }
  };

  const stopHandle = () => {
    setIsListening(false);
    microphoneRef.current.classList.remove("listening");
    SpeechRecognition.stopListening();
    resetTranscript();
  };

  useEffect(() => {
    if (props?.config?.allowMicrophone) {
      stopHandle();
    }
  }, [props.sent]);

  useEffect(() => {
    if (isListening) {
      let val =
        text.length > 0 ? finalTranscript.substr(text.length) : finalTranscript;
      props.setTextValue(props.textValue + " " + val);
    }

    setText(finalTranscript);
  }, [finalTranscript]);

  return (
    <div
      className={
        localStorage.getItem("openInFullScreen")
          ? "microphone-wrapper-fs"
          : "microphone-wrapper"
      }
    >
      {
        <div className="mircophone-container" style={{ display: "flex" }}>
          {props?.config?.allowMicrophone && (
            <div
              className="microphone-icon-container"
              ref={microphoneRef}
              onClick={handleClick}
            >
              {!isListening && (
                <img src={micro1} className="microphone-icon" alt="" />
              )}
              {isListening && (
                <img
                  src={micro2}
                  style={{ height: "20px", width: "20px" }}
                  className="microphone-icon"
                  alt=""
                />
              )}
            </div>
          )}
          {props?.config?.configDetails?.allowVoiceMicrophone &&
            !s360ConfigService?.config?.preview && (
              <div
                className="microphone-icon-container voice-record"
                onClick={props.handleVoiceMic}
              >
                <img
                  src={microVoice}
                  style={{ height: "20px", width: "20px" }}
                  className="microphone-icon"
                  alt=""
                />
              </div>
            )}
        </div>
      }
    </div>
  );
};

export default TextToSpeech;
